// One contingent's workspace on a tab: inventory, policies or rules (tkt/ContingentsRoutes.jsx). The ledger's
// filters and the Inventory view travel in the query.
import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { contingentsEnabled } from '../lib/accessGating';
import { ContingentWorkspaceRoute } from '../modules/venue-port/tkt/ContingentsRoutes';

export const Route = createFileRoute('/contingents/$contingentId/$tab')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: () => {
    if (!contingentsEnabled()) throw redirect({ to: '/', replace: true });
  },
  component: function ContingentTab() {
    const { tab } = Route.useParams();
    return <ContingentWorkspaceRoute tab={tab} />;
  },
});
